(function () {
  'use strict';
  const page = document.querySelector('[data-brand-advisor]');
  if (!page) return;
  page.dataset.preview = String(window.Shopify?.theme?.role === 'unpublished');
  const template = page.querySelector('[data-bal-template]');
  const manifest = JSON.parse(page.querySelector('[data-bal-assets]').textContent);
  ['styles','base'].forEach(key => manifest[key] = manifest[key].map(url => new URL(url, location.href).href));
  manifest.quote = new URL(manifest.quote, location.href).href;
  const form = page.querySelector('[data-bal-form]');
  const input = form.querySelector('textarea');
  const submit = form.querySelector('[type=submit]');
  const status = page.querySelector('[data-bal-status]');
  const host = page.querySelector('[data-bal-runtime]');
  const quote = page.querySelector('[data-bal-quote]');
  const brand = page.dataset.brand;
  const key = 'brand-advisor-input-' + brand;
  const loaded = new Map();
  let runtime, warmed = false, submitting = false;
  const ranges=[...page.querySelectorAll('[data-bal-range-src]')];
  const showRange=img=>{img.src=img.dataset.balRangeSrc;delete img.dataset.balRangeSrc;};
  if ('IntersectionObserver' in window) { const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){showRange(entry.target);observer.unobserve(entry.target);}}),{rootMargin:'80px'});ranges.forEach(img=>observer.observe(img)); }
  else ranges.forEach(showRange);
  try { input.value = sessionStorage.getItem(key) || ''; } catch {}
  input.addEventListener('input', () => { input.setCustomValidity(''); try { sessionStorage.setItem(key, input.value); } catch {} });
  function notice(text, error = false) { status.textContent = text; status.hidden = !text; status.dataset.error = String(error); }
  function warm() {
    if (warmed || navigator.connection?.saveData) return;
    warmed = true;
    const urls = [...manifest.base, ...Array.from(template.content.querySelectorAll('script[src]'), n => n.src), manifest.quote];
    [...new Set(urls)].forEach(href => { const link = document.createElement('link'); link.rel = 'preload'; link.as = 'script'; link.href = href; document.head.append(link); });
  }
  // Load the shared Advisor only when the customer starts a conversation.
  function asset(url, type, attributes = {}) {
    if (loaded.has(url)) return loaded.get(url);
    const task = new Promise((resolve, reject) => {
      const node = document.createElement(type === 'style' ? 'link' : 'script');
      if (type === 'style') { node.rel = 'stylesheet'; node.href = url; }
      else { node.src = url; node.async = false; }
      Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
      node.onload = () => resolve();
      node.onerror = () => { loaded.delete(url); node.remove(); reject(new Error('The advisor could not load. Please try again.')); };
      // Keep the landing layout last in the cascade as the shared styles arrive.
      const last = document.querySelector('link[href*="/brand-advisor.css"]');
      if (type === 'style' && last) last.before(node); else document.head.append(node);
    });
    loaded.set(url, task); return task;
  }
  async function start() {
    if (runtime) return runtime;
    warm();
    runtime = (async () => {
      if (!host.children.length) {
        const fragment = template.content.cloneNode(true);
        const scripts = [...fragment.querySelectorAll('script[src]')].map(n => ({url:n.src,attributes:Object.fromEntries([...n.attributes].filter(a => a.name.startsWith('data-')).map(a => [a.name,a.value]))}));
        const styles = [...fragment.querySelectorAll('link[rel=stylesheet]')].map(n => n.href);
        fragment.querySelectorAll('script[src],link[rel=stylesheet]').forEach(n => n.remove());
        host.append(fragment);
        const quoteMarkup = page.querySelector('[data-bal-quote-markup]');
        if (quoteMarkup) { host.querySelector('[data-requirements-planner]').append(...quoteMarkup.childNodes); quoteMarkup.remove(); }
        host._assets = {scripts,styles};
      }
      // Canonical brand also keeps the existing entry adapter and saved journeys consistent.
      const url = new URL(location.href); url.searchParams.set('brand', brand); history.replaceState(history.state, '', url);
      const resources = host._assets;
      await Promise.all([...new Set([...manifest.styles,...resources.styles])].map(url => asset(url,'style')));
      for (const url of manifest.base) await asset(url,'script');
      const base = new Set(manifest.base);
      for (const script of resources.scripts.filter(s => !base.has(s.url))) await asset(script.url,'script',script.attributes);
      await asset(manifest.quote,'script');
      const root = host.querySelector('[data-requirements-planner]');
      if (!root.smkAdvisor) throw new Error('The advisor could not start. Please try again.');
      const browse = root.querySelector('.rq-browse-link'); if (browse) browse.href = manifest.kitsLink;
      return root;
    })().catch(error => { runtime = null; throw error; });
    return runtime;
  }
  function reveal() { host.hidden = false; form.hidden = true; page.dataset.active = 'true'; }
  // Embedded advertising pages open the same runtime when reviewing a matched kit.
  page.smkBrandAdvisor = { async open() { const root = await start(); reveal(); return root; } };
  form.addEventListener('submit', async event => {
    event.preventDefault(); if (submitting) return;
    if (input.value.trim().length < 2) { input.setCustomValidity('Enter a model, a feature, or what you need.'); input.reportValidity(); return; }
    submitting = true; submit.disabled = true; notice('Finding your options…');
    try {
      if (!page.hasAttribute('data-ads-advisor') && input.value.trim().length < 15) { notice('Tell us which areas you want to cover, or how many cameras you need.'); input.focus(); return; }
      notice('Starting your advisor…');
      const root = await start();
      reveal();
      const work = root.smkAdvisor.match({text:input.value.trim(),request:{brand,brandAutomatic:false}});
      page.querySelector('.bal-chat').scrollIntoView({block:'start',behavior:'smooth'});
      await work;
    } catch (error) { if (host.hidden) notice(error.message, true); else { const message = host.querySelector('#rq-message'); message.hidden=false; message.textContent=error.message; message.setAttribute('role','alert'); } }
    finally { submitting=false;submit.disabled=false; }
  });
  quote.addEventListener('click', async () => {
    quote.disabled = true;
    try { const root = await start(); if (!root.smkAdvisor.adjustments.current()) root.querySelector('#rq-text').value=input.value; reveal(); root.querySelector('[data-advisor-quote]').click(); }
    catch (error) { notice(error.message, true); }
    finally { quote.disabled = false; }
  });
  // Restore an existing journey only when a customer explicitly returns to it.
  if (new URLSearchParams(location.search).has('advisor_view') || page.querySelector('[data-quote-success],[data-quote-errors]')) start().then(reveal).catch(error => notice(error.message,true));
})();
